import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retriggerRegistrations } from '../api/eventDetailsApi';
import type { RetriggerRegistrationRequest } from '../types';
import { registrationsQueryKey } from './useRegistrations';

interface UseRetriggerRegistrationsOptions {
  eventCode: string | undefined;
  accountCode: string | undefined;
}

export function useRetriggerRegistrations({
  eventCode,
  accountCode,
}: UseRetriggerRegistrationsOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: RetriggerRegistrationRequest[]) => retriggerRegistrations(request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: registrationsQueryKey(eventCode, accountCode),
      });
    },
  });
}